// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highcharts-data-label-sm{font-size:9px;font-weight:400}", ""]);
// Exports
module.exports = exports;
